import { FC } from "react";
import illustrations from "./illustrations";
import { IIllustrationProps } from "./types";

const sizes = {
  xxsmall: 12,
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 64,
  xlarge: 72,
  xxlarge: 92,
  xxxlarge: 104,
  obese: 125,
  logo: 140,
  image: 250,
};

const Illustration: FC<IIllustrationProps> = ({ name, size }) => {
  if (Object.keys(illustrations).includes(name)) {
    const Illustration = illustrations[name];

    return (
      <div>
        <Illustration width={size ? sizes[size] : sizes.medium} height={size ? sizes[size] : sizes.medium} />
      </div>
    );
  }
  console.error(`${String(name)} not found, using fallback`);
  return <div>No Icon found</div>;
};

export default Illustration;
